module.exports = __webpack_public_path__ + "static/img/Geos-2022-Charly.2f0d1a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Geos-2022-Charly.png
// module id = NyHe
// module chunks = 0